import { render } from "./HomeMainSlider.vue?vue&type=template&id=193ca4c2&scoped=true"
import script from "./HomeMainSlider.vue?vue&type=script&lang=js"
export * from "./HomeMainSlider.vue?vue&type=script&lang=js"

import "./HomeMainSlider.vue?vue&type=style&index=0&id=193ca4c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193ca4c2"]])

export default __exports__